import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ProviderComponent } from './components/provider.component';
import { ProviderRoutingModule } from './provider-routing.module';

@NgModule({
  declarations: [ProviderComponent],
  imports: [
    ProviderRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
  ],
})
export class ProviderModule {}

export function loadProviderModuleAsChild() {
  return Promise.resolve(ProviderModule);
}
